import api from 'dao/providers/axios';
import appconfig from 'config/appconfig';
import environment from 'lib/environment';

const apiBaseUrl = { baseURL: environment.get().api.castleServiceURL };
const recoveryPhoneNumberEndpoint = appconfig.endpoints.recoveryPhoneNumber;
const recoveryOptionsEndpoint = appconfig.endpoints.recoveryOptions;

export const daoGetRecoveryOptions = () =>  api.get(recoveryOptionsEndpoint, apiBaseUrl);

export const daoPatchRecoveryOptions = (authProp, payload) => api.patch(recoveryOptionsEndpoint, payload, { ...apiBaseUrl, headers: { Authorization: `${authProp}` } });

export const daoIntiateMobileVerification = (payload, authProp) => api.post(recoveryPhoneNumberEndpoint, payload, authProp ? { ...apiBaseUrl, headers: { Authorization: `${authProp}` } } : apiBaseUrl);

export const daoResendMobileVerificationCode = (id, payload) => api.post(`${recoveryPhoneNumberEndpoint}/${id}/code`, payload, apiBaseUrl);

export const daoDeleteMobileNumber = (authProp) => api.delete(recoveryOptionsEndpoint, { ...apiBaseUrl, headers: { Authorization: `${authProp}` } });

export const daoVerifyMobileCode = (id, payload) => api.put(`${recoveryPhoneNumberEndpoint}/${id}`, payload, apiBaseUrl);
